import { pages } from '@microsoft/teams-js';
import { useEffect, useState } from 'react';

import styles from './TabConfig.module.scss';

type TabSelection = 'alfred' | 'insights';

export const TabConfig = () => {
  const [selectedTab, setSelectedTab] = useState<TabSelection>('alfred');

  useEffect(() => {
    pages.config.registerOnSaveHandler(async saveEvent => {
      const contentUrl = `${window.location.origin}/app/${selectedTab}`;
      const websiteDomain =
        process.env.WEBSITE_DOMAIN ?? 'https://staging.rflx.co.uk';
      const websiteUrl = `${websiteDomain}/app/${selectedTab}`;

      try {
        await pages.config.setConfig({
          suggestedDisplayName: 'Reflexivity',
          entityId: `reflexivity-${selectedTab}`,
          contentUrl,
          websiteUrl,
        });
        saveEvent.notifySuccess();
      } catch {
        saveEvent.notifyFailure('Failed to save tab configuration');
      }
    });

    pages.config.setValidityState(true);
  }, [selectedTab]);

  return (
    <main className={styles.wrapper}>
      <h1 className={styles.title}>Configure Reflexivity Tab</h1>
      <p className={styles.description}>
        Choose which view to show in this tab.
      </p>
      <div className={styles.optionList}>
        <button
          className={styles.option}
          data-selected={String(selectedTab === 'alfred')}
          onClick={() => setSelectedTab('alfred')}
        >
          <span className={styles.optionTitle}>Alfred</span>
          <span className={styles.optionDescription}>
            AI-powered research and analysis assistant
          </span>
        </button>
        <button
          className={styles.option}
          data-selected={String(selectedTab === 'insights')}
          onClick={() => setSelectedTab('insights')}
        >
          <span className={styles.optionTitle}>Insights</span>
          <span className={styles.optionDescription}>
            Explore market themes and investment insights
          </span>
        </button>
      </div>
    </main>
  );
};
